import { render, staticRenderFns } from "./ShipmentOrder.vue?vue&type=template&id=f90326a0&scoped=true&"
import script from "./ShipmentOrder.vue?vue&type=script&lang=js&"
export * from "./ShipmentOrder.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentOrder.vue?vue&type=style&index=0&id=f90326a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90326a0",
  null
  
)

export default component.exports